/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "caravan--sprite",
  "use": "caravan--sprite-usage",
  "viewBox": "0 0 29 26",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 29 26\" id=\"caravan--sprite\"><path d=\"M28.356 18.308a.645.645 0 0 0-.645.64v1.283c0 .352-.29.64-.644.64h-1.29V4.847c0-2.115-1.74-4.846-3.866-4.846H3.867C1.74 0 0 2.73 0 4.846v15.385c0 1.057.87 1.923 1.933 1.923h1.29C3.382 24.3 5.187 26 7.41 26s3.996-1.699 4.189-3.846h15.467A1.934 1.934 0 0 0 29 20.23v-1.282a.645.645 0 0 0-.644-.641ZM1.289 6.128h3.867v3.205H1.289V6.128Zm6.122 18.59a2.88 2.88 0 0 1-2.9-2.885 2.88 2.88 0 0 1 2.9-2.884 2.88 2.88 0 0 1 2.9 2.884 2.88 2.88 0 0 1-2.9 2.885Zm6.122-3.846h-2.062c-.451-1.827-2.094-3.205-4.06-3.205-1.965 0-3.641 1.378-4.06 3.205H1.933a.645.645 0 0 1-.644-.641v-5.77h12.244v6.41Zm7.09 0h-5.8V9.974c0-.705.58-1.282 1.288-1.282h3.222a1.29 1.29 0 0 1 1.29 1.282v10.898Zm3.866 0H21.91v-6.41h2.578v6.41Zm0-7.692H21.91V9.974c0-1.41-1.16-2.564-2.578-2.564H16.11a2.579 2.579 0 0 0-2.578 2.564v3.206H1.29v-2.565h8.378A1.934 1.934 0 0 0 11.6 8.692V6.77c0-1.057-.87-1.923-1.933-1.923H1.289c0-1.41 1.16-3.564 2.578-3.564H21.91c1.418 0 2.578 2.154 2.578 3.564v8.334ZM6.444 9.333V6.128h3.223c.354 0 .644.289.644.641v1.923c0 .353-.29.641-.644.641H6.444Z\" fill=\"#232323\" /></symbol>"
});
sprite.add(symbol);
var viewBoxValues = symbol.viewBox ? symbol.viewBox.split(' ') : []

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox,
      width: viewBoxValues[2],
      height: viewBoxValues[3]
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.width = viewBoxValues[2];
SvgSpriteIcon.height = viewBoxValues[3];
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
